import { obterParametrosDaURL } from "../../../../functions";
import { apiAssinaturaDigital } from "../../api";
import { ApiException } from "../../api-exception";
import { IResumoOrcamentoRequest } from "./VerificarSolicitacaoRespondida";

export const ValidarContrato = async ({
  NumOrc,
  CodLoja,
}: IResumoOrcamentoRequest) => {
  const { token } = obterParametrosDaURL();

  try {
    await apiAssinaturaDigital.put(`/Signatario/validarcontrato`, null, {
      params: { NumOrc, CodLoja },
      headers: { token },
    });
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não foi possível validar o contrato de assinatura digital"
    );
  }
};